import type { MenuItem } from '@c/menu'
import Menu from '@c/menu'

const items: MenuItem[] = [
  { label: '个人主页', path: '/profile' },
  { label: '我的契约', path: '/profile/order' },
  { label: '我的受托', path: '/profile/undertake' },
  { label: '我的收货地址', path: '/profile/addr', divider: true },
  { label: '我的银行卡', path: '/profile/card' },
  { label: '公告', path: '/bulletin', divider: true },
  { label: '申请成为代理商', path: '/profile/join' },
]

const ProfileLayout = () => {
  return (
    <div className="flex gap-5">
      <Menu className="flex-none" items={items} title="个人中心" />
      <div className="w-full">
        <Outlet />
      </div>
    </div>
  )
}

export default ProfileLayout
